module.exports = __webpack_public_path__ + "img/trainingVideos.e4a85faf.svg";